import { render } from "./SidebarResultFooter.vue?vue&type=template&id=84ab8ecc&scoped=true&ts=true"
import script from "./SidebarResultFooter.vue?vue&type=script&lang=ts"
export * from "./SidebarResultFooter.vue?vue&type=script&lang=ts"

import "./SidebarResultFooter.vue?vue&type=style&index=0&id=84ab8ecc&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84ab8ecc"]])

export default __exports__